export default __webpack_public_path__ + "static/media/tapaOtono22_1.87db2b1b.jpg";